 $( document ).ready(function() {
   $( ".product-custom-description .cs-description h3" ).click(function() {
     $( ".product-custom-description .cs-description .cs-description-data" ).slideToggle("300ms");
     $( ".product-custom-description .cs-description img" ).toggleClass("clicked");
   });
   
   $( ".product-custom-description .cs-feature h3" ).click(function() {
     $( ".product-custom-description .cs-feature .cs-feature-data" ).slideToggle("300ms");
     $( ".product-custom-description .cs-feature img" ).toggleClass("clicked");
   });
 });